export default {
	SupNoDowns(state) {
		return state.SupNoDownList;
	},
	Total(state) {
		return state.Total;
	},
	IsLoading(state) {
		return state.IsLoading;
	}
};
